import { render, staticRenderFns } from "./HeadFertilizationTank.vue?vue&type=template&id=60f14289&scoped=true"
import script from "./HeadFertilizationTank.vue?vue&type=script&lang=js"
export * from "./HeadFertilizationTank.vue?vue&type=script&lang=js"
import style0 from "./HeadFertilizationTank.vue?vue&type=style&index=0&id=60f14289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f14289",
  null
  
)

export default component.exports